<template>
  <div>
    <div class="container px-1 d-none d-md-block">
      <div class="row">
        <div class="col-12">
          <div
            class="breadcrumb-row d-flex justify-content-between align-items-center flex-wrap px-0"
          >
            <!-- BREADCRUNB -->
            <div
              class="breadcrumb position-relative d-flex justify-content-start align-items-center nowrap mb-0 transparent_bg"
            >
              <div class="breadcrumb-item" v-if="item_one_link">
                <router-link :to="{ name: item_one_link }">{{
                  item_one
                }}</router-link>
              </div>
              <div class="breadcrumb-item" v-else>{{ item_one }}</div>
              <div class="breadcrumb-item" :class="[!item_two ? 'd-none' : '']">
                <template>
                  <router-link
                    :to="{
                      name: item_two_link,
                      params: {
                        id:
                          account_type === 'school' ||
                          account_type === 'teacher'
                            ? getCurrentClass
                            : getSelectedChildID,
                      },
                    }"
                    :class="item_two_selected ? 'brand_navy' : ''"
                    >{{ item_two }}</router-link
                  >
                </template>
              </div>
              <div class="breadcrumb-item" :class="item_four ? '' : 'active'">
                <router-link v-if="item_four" :to="item_three_link">{{
                  item_three
                }}</router-link>
                <span v-else>{{ item_three }} </span>
              </div>

              <div v-if="item_four" class="breadcrumb-item active">
                {{ item_four }}
              </div>
            </div>

            <!-- BREAD CRUMB NAVIGATION -->
            <template v-if="route_list_length > 1">
              <div
                class="breadcrumb-nav d-flex justify-content-end align-items-center nowrap font-14"
                v-if="show_nav"
              >
                <div
                  class="nav nav-left"
                  title="Prev"
                  @click="prevPage"
                  :class="false_current_page === 0 ? 'disabled' : 'brand_navy'"
                >
                  <span
                    class="icon-caret-fill-left color_grey_light"
                    :class="
                      false_current_page === 0 ? 'disabled' : 'brand_navy'
                    "
                  ></span>
                </div>
                <div class="page">
                  <span class="current">{{ current_page }}</span
                  >&nbsp;/
                  <span class="total">{{ route_list_length }}</span>
                </div>
                <div
                  class="nav nav-right"
                  title="Next"
                  @click="nextPage"
                  :class="
                    current_page === route_list_length
                      ? 'disabled'
                      : 'brand_navy'
                  "
                >
                  <span
                    class="icon-caret-fill-right color_grey_light"
                    :class="
                      current_page === route_list_length
                        ? 'disabled'
                        : 'brand_navy'
                    "
                  ></span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { randomString } from "@/scripts/utilities";
import { mapGetters } from "vuex";

export default {
  name: "BreadCrumb",

  props: {
    item_one: String,
    item_two: String,
    item_three: String,
    item_four: String,
    item_one_link: String,
    item_two_link: String,
    item_three_link: String,
    item_two_selected: {
      type: Boolean,
      default: false,
    },
    route_name: String,
    route_list: Array,
    route_list_length: Number,
    show_nav: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters(["getCurrentClass", "getSelectedChildID"]),
  },

  mounted() {
    this.updatePaging();
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      current_page: 1,
      false_current_page: 0,
    };
  },

  methods: {
    generateId(id) {
      return `${randomString(11)}${id}`;
    },

    updatePaging() {
      if (this.$route.query.page) {
        this.current_page = Number(this.$route.query.page);
        this.false_current_page = this.current_page - 1;
      } else {
        this.current_page = 1;
        this.false_current_page = 0;
      }
    },

    nextPage() {
      let next_id = Number(this.route_list[this.false_current_page + 1]);
      this.$router.push({
        name: this.route_name,
        query: {
          id: this.generateId(next_id),
          page: this.current_page + 1,
        },
      });
    },

    prevPage() {
      let prev_id = Number(this.route_list[this.false_current_page - 1]);
      this.$router.push({
        name: this.route_name,
        query: {
          id: this.generateId(prev_id),
          page: this.current_page - 1,
        },
      });
    },
  },
};
</script>

<style lang="scss">
// BREADCRUMB NAVIGATION
.breadcrumb-row {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $border_grey;
}

.breadcrumb {
  left: -12px;

  > .active {
    pointer-events: none;
    color: $brand_primary;
  }
}

.breadcrumb-item {
  text-transform: capitalize;
  color: $color_grey_light;
  color: $border_grey_dark;
  @include flex_row_start_nowrap;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.015em;

  + .breadcrumb-item {
    &::before {
      align-items: center;
      padding: 0 14px;
      content: "\ea14";
      font-family: "icomoon";
      font-weight: 600;
      font-size: 8px;
      color: $border_grey_dark;
    }
  }
}

.breadcrumb-nav {
  .nav {
    color: $border_grey_dark;
    cursor: pointer;

    &:hover {
      color: $brand_accent;
    }
  }

  .page {
    color: $brand_primary;
  }

  .nav-left {
    margin-right: 20px;
  }

  .nav-right {
    margin-left: 20px;
  }
}
</style>
